import axiosClient from './client';

export const changePassword = (password, passwordConfirmation) => (
  axiosClient().put('/auth/password/', { password, passwordConfirmation })
);

export const requestPassword = (email) => (
  axiosClient().post('/auth/password/', { email })
);

export const signIn = (email, password) => (
  axiosClient().post('/auth/sign_in/', { email, password })
);

export const signInWithGoogle = (googleIdToken) => (
  axiosClient().post('/auth/socials/sign_in_with_google', { googleIdToken })
)

export const signUpWithGoogle = (googleIdToken, communityId) => (
  axiosClient().post('/auth/socials/sign_up_with_google', { googleIdToken, communityId })
)

export const signInWithFacebook = (fbAccessToken) => (
  axiosClient().post('/auth/socials/sign_in_with_facebook', { fbAccessToken })
)

export const signUpWithFacebook = (fbAccessToken, communityId) => (
  axiosClient().post('/auth/socials/sign_up_with_facebook', { fbAccessToken, communityId })
)

export const signUp = ({ communityId, firstName, lastName, email, password, passwordConfirmation }) => axiosClient().post(
  '/auth', { user: { communityId, firstName, lastName, email, password, passwordConfirmation } }
)

export const signOut = () => (
  axiosClient().delete('/auth/sign_out/')
);
